import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import useActiveSubscriptionOverload from './useActiveSubscriptionOverload'

const useCheckModuleOnTrial = () => {
  const { company } = useCurrentSession()
  const { activeSubscriptionOverload } = useActiveSubscriptionOverload([company.id])

  const isModuleOnTrial = (chargebeeModuleId?: string | null): boolean => {
    if (!activeSubscriptionOverload || !chargebeeModuleId) return false
    return activeSubscriptionOverload.addonIds.includes(chargebeeModuleId)
  }

  return { isModuleOnTrial }
}

export default useCheckModuleOnTrial
